var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.items, function(item, i) {
        return _c("provider-search-result-item", {
          key: i,
          staticClass: "my-3",
          attrs: { data: item }
        })
      }),
      _vm.showPagination
        ? _c("pagination", {
            attrs: { data: _vm.pagination },
            on: { "pagination-go-page": _vm.pageChanged }
          })
        : _vm._e(),
      _vm.data.searched !== false && _vm.data.count === 0
        ? _c("result-not-found")
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }